module.exports = __webpack_public_path__ + "img/Lotus_japonicus.dc2eb722.jpg";